import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isLaborHours: false,
};

export const getLaborCodesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_LABOR_CODES_SUCCESS: {
      return {
        ...state,
        isLaborHours: true,
        response: action.payload?.data,
      };
    }

    case laborHoursConstant.GET_LABOR_CODES_FAILURE:
      return {
        ...state,
        isLaborHours: false,
        response: action.payload,
      };

    default:
      return state;
  }
};
